import { createRouter, createWebHistory } from "vue-router"
import { useAuthStore } from "@/stores/auth"
import { trackPageView } from "@/composables/useAnalytics"
import { toast } from "vue-sonner"

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            redirect: "/chat",
        },
        {
            path: "/chat",
            name: "chat",
            component: () => import("@/pages/Chat.vue"),
            meta: { requiresAuth: true },
        },
        {
            path: "/404",
            name: "not-found",
            component: () => import("@/pages/NotFound.vue"),
        },
        {
            path: "/:pathMatch(.*)*",
            redirect: "/404",
        },
    ],
})

router.beforeEach(async (to, _from, next) => {
    // Only initialize auth if authentication is enabled
    if (import.meta.env.VITE_ENABLE_AUTH) {
        const authStore = useAuthStore()

        if (!authStore.isInitialized) {
            await authStore.initializeAuth()
        }

        const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
        const isGuest = to.matched.some((record) => record.meta.guest)

        if (requiresAuth && !authStore.isAuthenticated) {
            const backofficeUrl = import.meta.env.VITE_BACKOFFICE_URL
            if (backofficeUrl) {
                window.location.href = `${backofficeUrl}/auth/login?redirectPath=${encodeURIComponent(window.location.origin + to.fullPath)}`
            } else {
                next({
                    name: "not-found"
                })
            }
            return
        }

        if (isGuest && authStore.isAuthenticated) {
            next("/chat")
            return
        }
    }

    next()
})

router.afterEach((to) => {
    const pageTitle = to.meta.title as string || document.title
    trackPageView(pageTitle, to.fullPath)
})

export default router
